import React from 'react';
import get from 'lodash/get';
import CreateACHImportMap from './CreateACHImportMap';
import SpinResolver from '../../../spinResolver/SpinResolver';
import {
  getACHDelimiters,
  getAvailableAccountTypes,
  getEndOfRecords,
  getTransactionCodes
} from '../../../../api/payments/service';
import useStyles from './CreateACHImportMapWrapper.styles';

export const CreateACHImportMapWrapperComponent = (props) => {
  const classes = useStyles();

  return (
    <SpinResolver
      services={[getACHDelimiters, getEndOfRecords, getTransactionCodes, getAvailableAccountTypes]}
      className={classes.spinnerWrapper}
    >
      {({
        results: [
          achDelimitersRowData,
          endOfRecordsRowData,
          transactionCodesRowData,
          accountTypesRowData
        ]
      }) => {
        const achDelimitersData = get(achDelimitersRowData, 'dropdown.source', []);
        const endOfRecordsData = get(endOfRecordsRowData, 'dropdown.source', []);
        const transactionCodesData = get(transactionCodesRowData, 'dropdown.source', []);
        const accountTypesData = get(accountTypesRowData, 'dropdown.source', []);

        if (
          !achDelimitersData.length ||
          !endOfRecordsData.length ||
          !transactionCodesData.length ||
          !accountTypesData.length
        ) {
          return null;
        }

        return (
          <div className={classes.wrapper}>
            <CreateACHImportMap
              accountTypesData={accountTypesData}
              achDelimitersData={achDelimitersData}
              endOfRecordsData={endOfRecordsData}
              transactionCodesData={transactionCodesData}
              {...props}
            />
          </div>
        );
      }}
    </SpinResolver>
  );
};

export default CreateACHImportMapWrapperComponent;
